import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const DataProtection = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', marginBottom: '30px', borderRadius: '8px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Data Protection & User Information Security Policy</h1>
            <p style={{ opacity: 0.9 }}>Operated by MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART)</p>
            <p style={{ opacity: 0.7, marginTop: '5px' }}>1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>1. Introduction</h2>
              <p style={{ color: '#374151' }}>
                This Policy outlines how we collect, process, store, and protect personal and sensitive information. It complies with the Digital Personal Data Protection Act, 2023, Information Technology Act, 2000, and GDPR where applicable.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>2. Data Collected</h2>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>Personal information (name, contact details)</li>
                <li style={{ marginBottom: '8px' }}>Transaction data</li>
                <li style={{ marginBottom: '8px' }}>Technical information (IP, device details)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>3. Data Security</h2>
              <p style={{ color: '#374151' }}>
                Data is stored on secure encrypted servers with SSL encryption, firewalls, and access controls.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>4. User Rights</h2>
              <p style={{ color: '#374151' }}>
                Users can access, rectify, delete data, or withdraw consent. Contact: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a> or call <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a>
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>5. Contact Information</h2>
              <p style={{ color: '#374151' }}><strong>MAXRAD SOFTWARE INDIA PVT LTD</strong></p>
              <p style={{ color: '#374151' }}>(Brand name ARTCARDO under the division DULCIA.ART)</p>
              <p style={{ color: '#374151' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
              <p style={{ color: '#374151' }}>Phone: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              <p style={{ color: '#374151' }}>Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DataProtection;
